module.exports = {
  theme: 'var(--color-theme)',
  theme20: 'var(--color-theme20)',
  bgBase: 'var(--color-bgBase)',
  content: 'var(--color-content)',
  content1: 'var(--color-content1)',
  content2: 'var(--color-content2)',
  content3: 'var(--color-content3)',
  contentLite: 'var(--color-contentLite)',
  subText: 'var(--color-subText)',
  grey: 'var(--color-grey)',
  grey90: 'var(--color-grey90)',
  grey80: 'var(--color-grey80)',
  grey60: 'var(--color-grey60)',
  grey70: 'var(--color-grey70)',
  grey50: 'var(--color-grey50)',
  grey40: 'var(--color-grey40)',
  grey30: 'var(--color-grey30)',
  grey20: 'var(--color-grey20)',
  grey10: 'var(--color-grey10)',
  greyLight: 'var(--color-greyLight)',
  grey12: 'var(--color-grey12)',
  primary: 'var(--color-primary)',
  primary5: 'var(--color-primary5)',
  primary10: 'var(--color-primary10)',
  primary20: 'var(--color-primary20)',
  primary30: 'var(--color-primary30)',
  primary40: 'var(--color-primary40)',
  primary50: 'var(--color-primary50)',
  primary60: 'var(--color-primary60)',
  primary70: 'var(--color-primary70)',
  primary80: 'var(--color-primary80)',
  primary90: 'var(--color-primary90)',
  primary100: 'var(--color-primary100)',
  primary110: 'var(--color-primary110)',
  primaryDark: 'var(--color-primaryDark)',
  primaryLite: 'var(--color-primaryLite)',
  primaryLite1: 'var(--color-primaryLite1)',
  primaryLite2: 'var(--color-primaryLite2)',
  primaryLite3: 'var(--color-primaryLite3)',
  primaryLite4: 'var(--color-primaryLite4)',
  primaryLite5: 'var(--color-primaryLite5)',
  primaryLite6: 'var(--color-primaryLite6)',
  primaryLite7: 'var(--color-primaryLite7)',
  primaryLite8: 'var(--color-primaryLite8)',
  primaryLite9: 'var(--color-primaryLite9)',
  primaryLite10: 'var(--color-primaryLite10)',
  primaryLite11: 'var(--color-primaryLite11)',
  primaryLiteBg: 'var(--color-primaryLiteBg)',
  error: 'var(--color-error)',
  error5: 'var(--color-error5)',
  error10: 'var(--color-error10)',
  error20: 'var(--color-error20)',
  error30: 'var(--color-error30)',
  error40: 'var(--color-error40)',
  error50: 'var(--color-error50)',
  errorLite: 'var(--color-errorLite)',
  errorLite1: 'var(--color-errorLite1)',
  errorLite2: 'var(--color-errorLite2)',
  errorLite3: 'var(--color-errorLite3)',
  errorLite4: 'var(--color-errorLite4)',
  errorLite5: 'var(--color-errorLite5)',
  disabledContent: 'var(--color-disabledContent)',
  disabledContentGrey: 'var(--color-disabledContentGrey)',
  borderGrey: 'var(--color-borderGrey)',
  borderGrey1: 'var(--color-borderGrey1)',
  borderGrey2: 'var(--color-borderGrey2)',
  borderGrey3: 'var(--color-borderGrey3)',
  borderGrey4: 'var(--color-borderGrey4)',
  borderGrey5: 'var(--color-borderGrey5)',
  borderGrey6: 'var(--color-borderGrey6)',
  borderGrey7: 'var(--color-borderGrey7)',
  bgGrey: 'var(--color-bgGrey)',
  bgGrey10: 'var(--color-bgGrey10)',
  bgGrey15: 'var(--color-bgGrey15)',
  bgGrey20: 'var(--color-bgGrey20)',
  bgGrey30: 'var(--color-bgGrey30)',
  bgGrey40: 'var(--color-bgGrey40)',
  bgGrey50: 'var(--color-bgGrey50)',
  bgGrey60: 'var(--color-bgGrey60)',
  bgGrey70: 'var(--color-bgGrey70)',
  bgGrey80: 'var(--color-bgGrey80)',
  bgGrey90: 'var(--color-bgGrey90)',
  textblack: 'var(--color-textblack)',
  neutral: 'var(--color-neutral)',
  greyStroke: 'var(--color-greyStroke)',
  greyBorder: 'var(--color-greyBorder)',
  transparentGrey: 'var(--color-transparentGrey)',
  verifiedGreen: 'var(--color-verifiedGreen)',
  lightGreen: 'var(--color-lightGreen)',
  darkGrey: 'var(--color-darkGrey)',
  selectionPrimary: 'var(--color-selectionPrimary)',
  whiteBorder: 'var(--color-whiteBorder)',
  yellow: 'var(--color-yellow)',
  yellow10: 'var(--color-yellow10)',
  yellow20: 'var(--color-yellow20)',
  yellow30: 'var(--color-yellow30)',
  yellow40: 'var(--color-yellow40)',
  yellow50: 'var(--color-yellow50)',
  yellow60: 'var(--color-yellow60)',
  yellow70: 'var(--color-yellow70)',
  yellowLite: 'var(--color-yellowLite)',
  yellowLite1: 'var(--color-yellowLite1)',
  yellowLite2: 'var(--color-yellowLite2)',
  yellowLite3: 'var(--color-yellowLite3)',
  yellowLite4: 'var(--color-yellowLite4)',
  grey1: 'var(--color-grey1)',
  grey2: 'var(--color-grey2)',
  grey3: 'var(--color-grey3)',
  grey4: 'var(--color-grey4)',
  blueGrey: 'var(--color-blueGrey)',
  warningYellow: 'var(--color-warningYellow)',
  warning500: 'var(--color-warning500)',
  meroon: 'var(--color-meroon)',
  blue: 'var(--color-blue)',
  blue1: 'var(--color-blue1)',
  blue2: 'var(--color-blue2)',
  blue3: 'var(--color-blue3)',
  blue4: 'var(--color-blue4)',
  blue5: 'var(--color-blue5)',
  blue6: 'var(--color-blue6)',
  blue7: 'var(--color-blue7)',
  greyText1: 'var(--color-greyText1)',
  darkText: 'var(--color-darkText)',
  pink10: 'var(--color-pink10)',
  pink20: 'var(--color-pink20)',
  brown10: 'var(--color-brown10)',
  gold10: 'var(--color-gold10)',
  gold20: 'var(--color-gold20)',
  gold30: 'var(--color-gold30)',
  warningBg: 'var(--color-warningBg)',
  attendanceAbsent: 'var(--color-attendanceAbsent)',
  attendancePresent: 'var(--color-attendancePresent)',
  attendanceText: 'var(--color-attendanceText)',
  progressBar: 'var(--color-progressBar)',
  progressBarText: 'var(--color-progressBarText)',
  grayDisabled: 'var(--color-grayDisabled)',
  blue8: 'var(--color-blue8)',
  orange: 'var(--color-orange)',
  green1: 'var(--color-green1)',
  pink30: 'var(--color-pink30)',
  pink40: 'var(--color-pink40)',
  orange10: 'var(--color-orange10)',
  grey11: 'var(--color-grey11)',
  pink1: 'var(--color-pink1)',
  content10: 'var(--color-content10)',
  content11: 'var(--color-content11)',
  warningRed: 'var(--color-warningRed)',
  progressBarBg: 'var(--color-progressBarBg)',
  primary4: 'var(--color-primary4)',
  primary4Gradient: 'var(--color-primary4Gradient)',

  // New Color List as per design patter
  // Do not create any new color below this line.
  // Use existing ones or create with above ones
  cofeePrimary1: 'var(--color-cofee-primary1)',
  cofeePrimary2: 'var(--color-cofee-primary2)',
  cofeePrimary3: 'var(--color-cofee-primary3)',
  cofeePrimary4: 'var(--color-cofee-primary4)',
  cofeePrimary5: 'var(--color-cofee-primary5)',
  cofeePrimary6: 'var(--color-cofee-primary6)',
  cofeePrimary7: 'var(--color-cofee-primary7)',
  cofeePrimary8: 'var(--color-cofee-primary8)',
  cofeePrimary9: 'var(--color-cofee-primary9)',
  cofeePrimary10: 'var(--color-cofee-primary10)',
  cofeeNeutral1: 'var(--color-cofee-neutral1)',
  cofeeNeutral2: 'var(--color-cofee-neutral2)',
  cofeeNeutral3: 'var(--color-cofee-neutral3)',
  cofeeNeutral4: 'var(--color-cofee-neutral4)',
  cofeeNeutral5: 'var(--color-cofee-neutral5)',
  cofeeNeutral6: 'var(--color-cofee-neutral6)',
  cofeeNeutral7: 'var(--color-cofee-neutral7)',
  cofeeNeutral8: 'var(--color-cofee-neutral8)',
  cofeeNeutral9: 'var(--color-cofee-neutral9)',
  cofeeNeutral10: 'var(--color-cofee-neutral10)',
  cofeeNeutral11: 'var(--color-cofee-neutral11)',
  cofeeNeutral12: 'var(--color-cofee-neutral12)',
  cofeeNeutral13: 'var(--color-cofee-neutral13)',
  cofeeRed1: 'var(--color-cofee-red1)',
  cofeeRed2: 'var(--color-cofee-red2)',
  cofeeRed3: 'var(--color-cofee-red3)',
  cofeeRed4: 'var(--color-cofee-red4)',
  cofeeRed5: 'var(--color-cofee-red5)',
  cofeeRed6: 'var(--color-cofee-red6)',
  cofeeRed7: 'var(--color-cofee-red7)',
  cofeeRed8: 'var(--color-cofee-red8)',
  cofeeRed9: 'var(--color-cofee-red9)',
  cofeeRed10: 'var(--color-cofee-red10)',
  cofeeYellow1: 'var(--color-cofee-yellow1)',
  cofeeYellow2: 'var(--color-cofee-yellow2)',
  cofeeYellow3: 'var(--color-cofee-yellow3)',
  cofeeYellow4: 'var(--color-cofee-yellow4)',
  cofeeYellow5: 'var(--color-cofee-yellow5)',
  cofeeYellow6: 'var(--color-cofee-yellow6)',
  cofeeYellow7: 'var(--color-cofee-yellow7)',
  cofeeYellow8: 'var(--color-cofee-yellow8)',
  cofeeYellow9: 'var(--color-cofee-yellow9)',
  cofeeYellow10: 'var(--color-cofee-yellow10)',
  cofeeGreen1: 'var(--color-cofee-green1)',
  cofeeGreen2: 'var(--color-cofee-green2)',
  cofeeGreen3: 'var(--color-cofee-green3)',
  cofeeGreen4: 'var(--color-cofee-green4)',
  cofeeGreen5: 'var(--color-cofee-green5)',
  cofeeGreen6: 'var(--color-cofee-green6)',
  cofeeGreen7: 'var(--color-cofee-green7)',
  cofeeGreen8: 'var(--color-cofee-green8)',
  cofeeGreen9: 'var(--color-cofee-green9)',
  cofeeGreen10: 'var(--color-cofee-green10)',
  cofeeBlue50: 'var(--color-cofee-blue50)',
  cofeeBlue75: 'var(--color-cofee-blue75)',
  cofeeBlue100: 'var(--color-cofee-blue100)',
  cofeeBlue200: 'var(--color-cofee-blue200)',
  cofeeBlue300: 'var(--color-cofee-blue300)',
  cofeeBlue400: 'var(--color-cofee-blue400)',
  cofeeBlue500: 'var(--color-cofee-blue500)',
  cofeeTeal50: 'var(--color-cofee-teal50)',
  cofeeTeal75: 'var(--color-cofee-teal75)',
  cofeeTeal100: 'var(--color-cofee-teal100)',
  cofeeTeal200: 'var(--color-cofee-teal200)',
  cofeeTeal300: 'var(--color-cofee-teal300)',
  cofeeTeal400: 'var(--color-cofee-teal400)',
  cofeeTeal500: 'var(--color-cofee-teal500)',
  cofeeLime50: 'var(--color-cofee-lime50)',
  cofeeLime75: 'var(--color-cofee-lime75)',
  cofeeLime100: 'var(--color-cofee-lime100)',
  cofeeLime200: 'var(--color-cofee-lime200)',
  cofeeLime300: 'var(--color-cofee-lime300)',
  cofeeLime400: 'var(--color-cofee-lime400)',
  cofeeLime500: 'var(--color-cofee-lime500)',
  cofeePurple50: 'var(--color-cofee-purple50)',
  cofeePurple75: 'var(--color-cofee-purple75)',
  cofeePurple100: 'var(--color-cofee-purple100)',
  cofeePurple200: 'var(--color-cofee-purple200)',
  cofeePurple300: 'var(--color-cofee-purple300)',
  cofeePurple400: 'var(--color-cofee-purple400)',
  cofeePurple500: 'var(--color-cofee-purple500)',
  cofeeViolet50: 'var(--color-cofee-violet50)',
  cofeeViolet75: 'var(--color-cofee-violet75)',
  cofeeViolet100: 'var(--color-cofee-violet100)',
  cofeeViolet200: 'var(--color-cofee-violet200)',
  cofeeViolet300: 'var(--color-cofee-violet300)',
  cofeeViolet400: 'var(--color-cofee-violet400)',
  cofeeViolet500: 'var(--color-cofee-violet500)',
  cofeeOrange50: 'var(--color-cofee-orange50)',
  cofeeOrange75: 'var(--color-cofee-orange75)',
  cofeeOrange100: 'var(--color-cofee-orange100)',
  cofeeOrange200: 'var(--color-cofee-orange200)',
  cofeeOrange300: 'var(--color-cofee-orange300)',
  cofeeOrange400: 'var(--color-cofee-orange400)',
  cofeeOrange500: 'var(--color-cofee-orange500)',
  cofeeRose50: 'var(--color-cofee-rose50)',
  cofeeRose75: 'var(--color-cofee-rose75)',
  cofeeRose100: 'var(--color-cofee-rose100)',
  cofeeRose200: 'var(--color-cofee-rose200)',
  cofeeRose300: 'var(--color-cofee-rose300)',
  cofeeRose400: 'var(--color-cofee-rose400)',
  cofeeRose500: 'var(--color-cofee-rose500)'
};
